import { Coffee } from 'lucide-react';

export function BuyMeCoffee() {
  return (
    <div className="fixed bottom-4 right-4 z-40 md:bottom-6 md:right-6">
      <a
        href="https://www.buymeacoffee.com/ksanjeev284"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center px-4 py-2 bg-[#FFDD00]/90 hover:bg-[#FFDD00] 
        text-black rounded-full hover:shadow-lg transition-all duration-200 font-medium 
        backdrop-blur-sm hover:backdrop-blur-0"
        aria-label="Buy me a coffee on buymeacoffee.com"
      >
        <Coffee className="w-5 h-5 mr-2" aria-hidden="true" />
        <span className="hidden sm:inline">Buy me a coffee</span>
        <span className="sm:hidden">Coffee</span>
      </a>
    </div>
  );
}